import { GetVenueRentalVersionDatesResponseType as ApiGetVenueRentalVersionDatesResponseType } from 'src/api/generated/touring/types';
import { VenueRentalVersionDatesResponseType } from './types';

export const mapVenueRentalVersionDatesResponseType = (
  apiType: ApiGetVenueRentalVersionDatesResponseType
): VenueRentalVersionDatesResponseType => {
  return apiType.data;
};
